import React, { useMemo, useState } from 'react'
import List from '@embracesbs/component-list/List'
import { Tenant } from '../../Interfaces/Types'
import Text from '@embracesbs/component-text'
import Icon from '@embracesbs/component-icon'
import { itemColor } from '../../Utilities/helpers/helpers'
import { useTenants } from '../Context/TenantContext'
import { useSubscriptions } from '../Context/SubscriptionContext'
import TenantListItem from './TenantListItem'
import AddCard from '../Common/AddCard'
import SectionHeader from '../Common/SectionHeader'
import { AddTenant } from '../Section1/Modals'

interface TenantListProps {
  query: string
}
const TenantList: React.FC<TenantListProps> = ({ query }) => {
  const { selectedSubscriptionId, selectedSubscription } = useSubscriptions()
  const { tenants, loading, addTenant } = useTenants()
  const [addModalOpen, setAddModalOpen] = useState(false)

  const filteredTenants = useMemo(() => {
    return tenants
      .filter((tenant: { tenantName: string }) => tenant.tenantName.toLowerCase().includes(query.toLowerCase()))
      .sort((a: { tenantName: string }, b: { tenantName: string }) =>
        a.tenantName.localeCompare(b.tenantName, undefined, { sensitivity: 'base' })
      )
  }, [tenants, query])

  if (selectedSubscriptionId === null) return null

  const renderList = () => {
    if (loading) {
      return (
        <Icon
          color={itemColor(undefined, false)}
          iconName='EmailActionSync1'
          size={16}
          style={{
            width: '100%',
            margin: '0 9px 0 0 ',
            animation: 'spin 1s linear infinite'
          }}
        />
      )
    }

    if (filteredTenants.length === 0) {
      return (
        <Text content={'No tenants found'} style={{ textAlign: 'center', display: 'block', marginBottom: '6px' }} textColor='grey'></Text>
      )
    }

    return (
      <List as='div' role='list' ariaLabel='Tenant List'>
        {filteredTenants.map((item: Tenant) => (
          <TenantListItem key={item.id} tenant={item} />
        ))}
      </List>
    )
  }

  return (
    <>
      <SectionHeader title='Tenants' />
      <AddCard
        label={selectedSubscription?.customerName ? `Add tenant to ${selectedSubscription.customerName}` : 'Add tenant'}
        onClick={() => setAddModalOpen(true)}
      />
      {renderList()}
      {addModalOpen && <AddTenant onCreated={(data) => addTenant(data)} onClosed={() => setAddModalOpen(false)} isOpen={addModalOpen} />}
    </>
  )
}

export default TenantList
